module.exports = __webpack_public_path__ + "img/sticker2.2edb2ebe.png";